/** Shown when delete is attempted on a self-frozen object or frozen group shell (SC-R-04/08). */
export const FROZEN_DELETE_MESSAGE = 'Cannot delete a frozen object. Unfreeze it first.'

/** Auto-dismiss for {@link FROZEN_DELETE_MESSAGE}. */
export const FROZEN_DELETE_TOAST_DURATION_MS = 3000

/** True when delete should be disabled or blocked for self-frozen selection members. */
export function selectionIncludesSelfFrozenForDelete(
  shapes: readonly { frozen?: boolean }[],
  textBoxes: readonly { frozen?: boolean }[]
): boolean {
  return (
    shapes.some((shape) => shape.frozen === true) || textBoxes.some((box) => box.frozen === true)
  )
}

/** Shown when delete is attempted on children inside a frozen group (e.g. isolation mode). */
export const FROZEN_GROUP_CHILD_DELETE_MESSAGE =
  'Cannot delete objects inside a frozen group. Unfreeze the group first.'

/** Shown when ungroup is attempted on a frozen group. */
export const FROZEN_UNGROUP_MESSAGE = 'Cannot ungroup a frozen group. Unfreeze it first.'

/** Shown when ungroup is attempted on a locked group. */
export const LOCKED_UNGROUP_MESSAGE = 'Cannot ungroup a locked group. Unlock it first.'

/** Shown when node edit is attempted on a frozen pen path. */
export const FROZEN_NODE_EDIT_MESSAGE =
  'Cannot edit path nodes on a frozen object. Unfreeze it first.'

/** Shown when "Edit Path" / "Convert text to shape" is attempted on a frozen shape or text box. */
export const FROZEN_CONVERT_MESSAGE = 'Cannot convert a frozen object. Unfreeze it first.'

/** Shown when "Crop Photo" is attempted on a frozen photo-filled shape. */
export const FROZEN_CROP_MESSAGE = 'Cannot crop a frozen object. Unfreeze it first.'

/** Object panel freeze switch tooltip while editing inside a group. */
export const FREEZE_UNAVAILABLE_IN_GROUP_MESSAGE =
  'Freeze is not available inside a group. Ungroup first to freeze individual objects.'

/** Shown when freeze is attempted on a selection that contains locked objects. */
export const FREEZE_BLOCKED_BY_LOCK_MESSAGE = 'Cannot freeze a locked object. Unlock it first.'

/** Shown when lock is attempted on a selection that contains frozen objects. */
export const LOCK_BLOCKED_BY_FREEZE_MESSAGE = 'Cannot lock a frozen object. Unfreeze it first.'
